<template>
<div>

  <div class = "section columns is-centered endarea">
    <div class = "column is-6">
        <div class = "section">
            <div class = "title title-font"> Solicita tu presupuesto </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Nueva contraseña</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <input class="input" :class = "{'is-danger': passwordWrong}" type="text" placeholder="Introduce tu nueva contraseña" v-model = "password">
                  </div>
                  <p class="help is-danger" v-show = "passwordWrong">
                    La contraseña debe tener al menos 6 caracteres
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Repite la contraseña</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <input class="input" :class = "{'is-danger': passwordRWrong || passwordsDontMatch}" type="text" placeholder="Introduce tu nueva contraseña" v-model = "repeatPassword">
                  </div>
                  <p class="help is-danger" v-show = "passwordRWrong">
                    La contraseña debe tener al menos 6 caracteres
                  </p>
                  <p class="help is-danger" v-show = "passwordsDontMatch">
                    Las contraseñas no coinciden
                  </p>
                </div>
              </div>
            </div>


            <div class = "field">
                <div class = "control">
                  <a class ="button is-success" @click = "sendMessage" > Enviar </a>
                </div>
            </div>
        </div>

    </div>

  </div>

  <div class="modal" :class="{'is-active': finished}">
    <div class="modal-background"></div>
    <div class="modal-content">
      <header class="modal-card-head">
        <p class="modal-card-title">Tu contraseña ha sido cambiada</p>
        <button class="delete" @click="goToMain()"></button>
      </header>
      <section class="modal-card-body">
        Ya puedes iniciar sesión con la nueva contraseña
      </section>
      <footer class="modal-card-foot">
        <a class="button is-primary"  @click="goToMain()">OK</a>
      </footer>
    </div>
    <button class="modal-close is-large"></button>
  </div>

</div>
</template>

<script>

import {requester} from '../App.vue';
import _ from 'lodash';

export default {
  name: 'ResetPassword',
  data() {
    return { 
      password: "",
      repeatPassword: "",
      passwordWrong: false,
      passwordRWrong: false,
      finished: false,
      token: "",
      passwordsDontMatch: true
    }
  },
  methods: {
    sendMessage: _.debounce(function(){

      this.passwordsDontMatch = false;

      if(!this.password || this.password.length < 6){
        this.passwordWrong = true;
      } else {
        this.passwordWrong = false;
      }

      if(!this.repeatPassword || this.password.length < 6){
        this.passwordRWrong = true;
      } else {
        this.passwordRWrong = false;
      }

      if(this.passwordWrong || this.passwordRWrong){
        return;
      }

      if(this.password != this.repeatPassword){
        this.passwordsDontMatch = true;
        return;
      }

      this.passwordsDontMatch = false;

      /*let formData = new FormData();
      formData.append('name', this.name);*/

      requester.post('resetPassword/' + this.token, {
        password: this.password
      },
      ).then(() => {
        this.finished = true;

      }).catch(() => {
        
      })

    }, 200, {leading: true}),
    goToMain: function(){
      this.$router.push("/");
    }
  },
  mounted: function(){
    this.token = this.$route.params.token;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang = "scss">
.title-font {
  font-family: "Baloo Bhaina 2";
}

h1, h2 {
  font-weight: normal;
}
div {
  text-align: center;
  font-family: 'Century Gothic', 'Tahoma', 'Verdana'
}
.footer {
  background-color: #222222;
}

.list-style {
  list-style-position: inside;
  padding: 2px;
  list-style-type:disc;
}

.dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: lightcyan;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    position: relative;
    cursor: pointer;
  }

.dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
  }

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

.input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

.tag-image {
  margin-right: 0.5rem; 
  margin-top: auto; 
  margin-bottom: auto;
}
</style>
